import { showWarningMessage } from "../../../_component/MessageSnack";
import axiosInstance from "../../../_config/AxiosInstance";
import config from "../../../_config/config";
import { contactConstants } from "../../constant";

export const fetch_user_contacts_action = () => async (dispatch) => {
  dispatch({
    type: contactConstants.FETCH_USER_CONTACT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.bookmarks.userContacts);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: contactConstants.FETCH_USER_CONTACT_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: contactConstants.FETCH_USER_CONTACT_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const update_user_contact_action = (id, status) => async (dispatch) => {
  dispatch({
    type: contactConstants.UPDATE_USER_CONTACT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(
      `${config.bookmarks.contact}/${id}`,
      status
    );
    if (response.status) {
      let data = response.data;
      dispatch({
        type: contactConstants.UPDATE_USER_CONTACT_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: contactConstants.UPDATE_USER_CONTACT_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};

// action to create a new contacts
export const create_user_contact_action = (data) => async (dispatch) => {
  dispatch({
    type: contactConstants.CREATE_USER_CONTACT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.bookmarks.contact, data);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: contactConstants.CREATE_USER_CONTACT_ACTION_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: contactConstants.CREATE_USER_CONTACT_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    return null;
  }
};

export const fetch_user_contact_details_action = (id) => async (dispatch) => {
  dispatch({
    type: contactConstants.FETCH_USER_CONTACT_DETAILS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      `${config.bookmarks.contact}/${id}`
    );
    if (response.status) {
      let data = response.data;
      dispatch({
        type: contactConstants.FETCH_USER_CONTACT_DETAILS_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: contactConstants.FETCH_USER_CONTACT_DETAILS_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const delete_user_contact_action = (id) => async (dispatch) => {
  dispatch({
    type: contactConstants.DELETE_USER_CONTACT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.delete(
      `${config.bookmarks.contact}/${id}`
    );
    if (response.status) {
      let data = response.data;
      dispatch({
        type: contactConstants.DELETE_USER_CONTACT_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: contactConstants.DELETE_USER_CONTACT_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};
